/**
 * LiangCollection UI Fidelity (A1) — single source of truth for the
 * "网站" (Website) module's sub-navigation, shared by:
 *  - `WorkspaceLayout.tsx`, which renders these as a real nested SubMenu
 *    inside Vistoera's ONE primary dark Sider (no second gray sidebar —
 *    spec §1/§2), and
 *  - `WebsiteSitePage.tsx`, whose `<Routes>` must expose the exact same
 *    keys as real, directly-openable, refreshable routes (spec §3/§8).
 */

export interface WebsiteNavItem {
  key: string
  labelKey: string
}

export interface WebsiteNavGroup {
  titleKey: string
  items: WebsiteNavItem[]
}

const WEBSITE_ITEM_KEYS: Record<string, string> = {
  items: 'tenantNav.website.items',
  exhibitions: 'tenantNav.website.exhibitions',
  research: 'tenantNav.website.research',
  'graphic-pages': 'tenantNav.website.graphicPages',
  categories: 'tenantNav.website.categories',
  topics: 'tenantNav.website.topics',
  design: 'tenantNav.website.design',
  preview: 'tenantNav.website.preview',
}

export const WEBSITE_NAV_GROUPS: WebsiteNavGroup[] = [
  { titleKey: 'tenantNav.website.groups.items', items: [{ key: 'items', labelKey: WEBSITE_ITEM_KEYS.items }] },
  { titleKey: 'tenantNav.website.groups.exhibitions', items: [{ key: 'exhibitions', labelKey: WEBSITE_ITEM_KEYS.exhibitions }] },
  { titleKey: 'tenantNav.website.groups.research', items: [{ key: 'research', labelKey: WEBSITE_ITEM_KEYS.research }] },
  { titleKey: 'tenantNav.website.groups.graphicPages', items: [{ key: 'graphic-pages', labelKey: WEBSITE_ITEM_KEYS['graphic-pages'] }] },
  {
    titleKey: 'tenantNav.website.groups.basics',
    items: [
      { key: 'categories', labelKey: WEBSITE_ITEM_KEYS.categories },
      { key: 'topics', labelKey: WEBSITE_ITEM_KEYS.topics },
      { key: 'design', labelKey: WEBSITE_ITEM_KEYS.design },
      { key: 'preview', labelKey: WEBSITE_ITEM_KEYS.preview },
    ],
  },
]

/** Flat ordered list of every real "网站" sidebar child — group titles
 * are visual-only in LiangCollection admin and must not appear in the
 * tenant left nav (VISTOERA_LEFT_NAV_UI_STRUCTURE_FIX_P0). */
export const WEBSITE_NAV_ITEMS: WebsiteNavItem[] = WEBSITE_NAV_GROUPS.flatMap((g) => g.items)

/** Flat list of every real sub-route key under `/website/:siteId/`. */
export const WEBSITE_NAV_KEYS: string[] = WEBSITE_NAV_GROUPS.flatMap((g) => g.items.map((i) => i.key))
